//const baseUrl = 'https://aorusv2-southeastasia-web-testing.azurewebsites.net';
const baseUrl = 'https://www.aorus.com';
const customItemImage = {
    226: baseUrl + '/webui/header/wallpaper.jpg',
    234: baseUrl + '/webui/header/GCC.jpg',
    235: baseUrl + '/webui/header/aitop.jpg'
};

function midTextTransformer(data) {
    const { TranslateText } = data;
    const Text = TranslateText ?? "";
    data.Text = Text;
}
function classnames(...props) {
    return props.map(prop => {
        if (typeof prop === 'object' && prop !== null) {
            return Object.entries(prop).filter(([key, value]) => !!value).map(([key]) => key).join(' ');
        } else {
            return prop;
        }
    }).join(' ');
};
const template = {
    FlyoutNavItem({ Text, ChildData, MenuID }) {
        return (`
<div class=${classnames('nav-item', { open: false })}>
    <div class="nav-submenu-trigger">${Text}</div>
        ${Submenu({
            children: SubmenuGroup({
                children: ChildData.map(SubmenuItem)
            })
        })}
</div>
                `)
    },
    Submenu({ children }) {
        return `
<div class='nav-submenu'>
    <div class="nav-scroll-container">
        <div class="nav-content-wrapper">
            <div class="nav-submenu-content">
                <div class="nav-submenu-group-container">${children}</div>
            </div>
        </div>
    </div>
</div>
`
    },
    SubmenuGroup({ children, Text }) {
        return `
<div class="nav-submenu-group">
    ${Text ?
                `<div class="nav-submenu-header">${Text}</div>` : ""
            }
    <ul class="nav-submenu-list">${children}</ul>
</div>
    `;
    },
    SubmenuItem({ Text, ImgUrl, ChildData, RedirectURL, MenuID }) {
        //暴力法: 依id插入客製圖片
        if(MenuID in customItemImage){
            ImgUrl = customItemImage[MenuID];
        }

        let triggerHTML = ImgUrl ? `
<figure>
    <img src="${ImgUrl}" />
    <p>${Text}</p>
</figure>
`: `
${MenuID in menuIconClass ? (
            `<i class="${classnames("icon-nav-pi", menuIconClass[MenuID])}"></i>`
        ) : ""} 
<span>${Text}</span>
`

        return `
<li class='nav-submenu-list-item'>
    <a href="${RedirectURL}" class="${classnames("nav-submenu-link", "nav-submenu-trigger")}">
        ${triggerHTML}
    </a>
    ${ChildData?.length > 0 ? (
                Submenu({
                    children: ChildData.map((childData, index) =>
                        SubmenuGroup({
                            TranslateText: childData.TranslateText,
                            children: childData.ChildData.map(SubmenuItem)
                        })
                    )
                })
            ) : ""
            }
</li >
    `
    },
    MemberInfoList({ ChildData }) {
        return ChildData.map(MemberInfoItem).join('');
    },
    MemberInfoItem({ RedirectURL, Text }) {
        return `<li><a href="${RedirectURL}">${Text}</a></li>`
    },
    SearchItem({ Text }) {
        return `<li><span>${Text}</span> <button class="search-history-delete"></button></li>`;
    },
    AorusHeader({ aorusurl, gigabyteurl, ChildData, LoginArea }) {
        return (`
    <div class='aorus-header-v2 aorus-sticky-header' >
        <div class='header-content'>
            <div class='nav-menutrigger'>
                <button class='nav-menutrigger-button'></button>
            </div>
            <div class="header-left">
                <a href="${aorusurl}" class="nav-link nav-item-logo">
                    <span class="logo logo-aorus"></span>
                </a>
            </div>
            <div id='aorus-header-nav' class='header-nav'>
                <div class="header-nav-flyout"></div>
                <div class="header-mobile-subtitle"></div>
                <div class="nav-content">
                    <div class='nav-menu'>
                        ${ChildData.map(FlyoutNavItem).join('')}
                    </div>
                    <div class="header-menu-optional">
                        <a class="nav-link header-gbt-logo" href="//${gigabyteurl}" title="GIGABYTE">
                            <svg class="GIGABYTECiLogo" xmlns="http://www.w3.org/2000/svg" width="160" height="20.915" viewBox="0 0 160 20.915">
                                <g id="CI" transform="translate(0 0)">
                                    <path id="GIGABYTE" d="M124.69,20.915V4.131h-5.181V0h15.882V4.131h-5.145V20.915Zm-20.091,0V13.03L96.864,0h6.421l4.092,8.411L111.432,0h6.42l-7.659,13.03v7.885Zm-24.712,0V0H89.5c3.9,0,6.8,1.727,6.8,5.294,0,2.629-1.351,4.093-3.679,4.882v.075c2.778.563,4.243,2.065,4.243,4.618,0,4.994-4.393,6.045-8.148,6.045Zm5.557-3.943H87.1c2.028,0,4.169-.3,4.169-2.44,0-2.291-2.178-2.479-4.093-2.479H85.444Zm1.577-8.712c1.839,0,3.717-.451,3.717-2.216,0-1.914-1.8-2.1-3.642-2.1H85.481V8.261Zm-1.54,0h-.038ZM71.427,20.915l-1.577-4.469H62L60.35,20.915H54.68L62.64,0h6.834l8.072,20.915ZM63.278,12.5h5.257L66.057,4.318h-.075ZM43.365,20.915A10.558,10.558,0,0,1,32.813,10.476,10.385,10.385,0,0,1,43.552.075l8.561.038V4.581H44.454c-3.717.3-5.745,2.742-5.745,5.9A5.875,5.875,0,0,0,44.3,16.108h1.615a.662.662,0,0,0,.676-.676V8.861H52.3V20.915Zm-19.259,0V.075h5.557v20.84Zm-13.517,0A10.566,10.566,0,0,1,0,10.476,10.385,10.385,0,0,1,10.739.075L19.3.113V4.581H11.64c-3.717.3-5.745,2.742-5.745,5.9a5.875,5.875,0,0,0,5.6,5.632H13.1a.662.662,0,0,0,.676-.676V8.861h5.745V20.915Zm127.259-.038V0H152.6V3.943h-9.162V8.261h8.673V12.2h-8.673v4.731h9.5v3.943Zm21.59-17.8V.676l-.677,2.4h-.6l-.6-2.4v2.4H157V0h.938l.563,2.1.564-2.1H160V3.08Zm-4.356,0V.526h-.9V0h2.441V.526h-.9V3.08Z" transform="translate(0 0)"></path>
                                </g>
                            </svg>
                        </a>
                        <div class="split-line"></div>
                    </div>
                </div>
            </div>
            <div class="header-right">                
                <div class="right-item">
                    <a href="#" class="btn-search right-submenu-trigger">
                        <svg class="icon-search" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.02177 2.1522C4.78009 2.1522 2.1522 4.78009 2.1522 8.02177C2.1522 11.2634 4.78009 13.8913 8.02177 13.8913C11.2634 13.8913 13.8913 11.2634 13.8913 8.02177C13.8913 4.78009 11.2634 2.1522 8.02177 2.1522ZM0.195679 8.02177C0.195679 3.69954 3.69954 0.195679 8.02177 0.195679C12.344 0.195679 15.8479 3.69954 15.8479 8.02177C15.8479 12.344 12.344 15.8479 8.02177 15.8479C3.69954 15.8479 0.195679 12.344 0.195679 8.02177Z" fill="#CCCCCC" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1996 13.1996C13.5816 12.8176 14.201 12.8176 14.5831 13.1996L17.5179 16.1344C17.8999 16.5164 17.8999 17.1358 17.5179 17.5179C17.1358 17.8999 16.5164 17.8999 16.1344 17.5179L13.1996 14.5831C12.8176 14.201 12.8176 13.5816 13.1996 13.1996Z" fill="#CCCCCC" />
                        </svg>
                    </a>
                    <div class="nav-submenu">
                        <div class="nav-scroll-container">
                            <div class="nav-content-wrapper">
                                <div class="nav-submenu-content">
                                    <div class="header-search">
                                        <div class="searchbar">
                                            <input class="seach-input" type="text" placeholder="Search AORUS.com" name="search" autocomplete="off" />
                                            <div class="search-icon">
                                                <svg class="icon-search" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.02177 2.1522C4.78009 2.1522 2.1522 4.78009 2.1522 8.02177C2.1522 11.2634 4.78009 13.8913 8.02177 13.8913C11.2634 13.8913 13.8913 11.2634 13.8913 8.02177C13.8913 4.78009 11.2634 2.1522 8.02177 2.1522ZM0.195679 8.02177C0.195679 3.69954 3.69954 0.195679 8.02177 0.195679C12.344 0.195679 15.8479 3.69954 15.8479 8.02177C15.8479 12.344 12.344 15.8479 8.02177 15.8479C3.69954 15.8479 0.195679 12.344 0.195679 8.02177Z" fill="#CCCCCC" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1996 13.1996C13.5816 12.8176 14.201 12.8176 14.5831 13.1996L17.5179 16.1344C17.8999 16.5164 17.8999 17.1358 17.5179 17.5179C17.1358 17.8999 16.5164 17.8999 16.1344 17.5179L13.1996 14.5831C12.8176 14.201 12.8176 13.5816 13.1996 13.1996Z" fill="#CCCCCC" />
                                                </svg>
                                            </div>
                                            <button class="search-close" title="clear"></button>
                                        </div>
                                        <div class="search-history">
                                            <div class="search-history-title">Recent Search</div>
                                            <ul class="search-history-list">
                                            ${/* SearchItem[] */""}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="login-area">
                    <button class="login-button">
                        <svg class="chibi-head" width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.7838 13.0445C14.853 13.7291 14.9221 14.7205 14.8747 15.6449C14.8478 16.1686 14.7845 16.6491 14.6727 17.0318C14.5569 17.4279 14.4118 17.6415 14.2808 17.733L14.2803 17.7334C14.2786 17.7344 14.2763 17.7357 14.2734 17.7374C14.2597 17.7451 14.234 17.7584 14.1977 17.7731C14.125 17.8023 14.013 17.8353 13.8696 17.8412C13.6052 17.852 13.1612 17.7736 12.5984 17.2512L12.3146 16.8545L12.3083 16.3592L12.3058 16.1619L12.469 15.9582C12.5042 15.9142 12.5391 15.8699 12.5764 15.8223C12.6399 15.7414 12.7108 15.6512 12.8034 15.5376L12.8035 15.5377L12.8089 15.5307C13.1572 15.0877 13.6263 14.4991 14.0969 13.9086L14.0973 13.908C14.3517 13.5879 14.5805 13.3001 14.7838 13.0445ZM5.07204 15.638C5.02452 14.7115 5.09415 13.7171 5.16349 13.0308C5.3609 13.2788 5.59055 13.5675 5.8577 13.9038L5.85769 13.9038L5.85932 13.9058L7.51168 15.9636L7.64115 16.1248L7.63845 16.341L7.63209 16.8503L7.34828 17.2469C6.78577 17.769 6.34229 17.8463 6.07838 17.8349C5.93513 17.8287 5.82317 17.7954 5.75035 17.7658C5.71398 17.7511 5.68827 17.7376 5.67452 17.7298C5.67155 17.7282 5.66923 17.7268 5.66759 17.7258L5.66592 17.7246C5.53482 17.633 5.3897 17.4196 5.27401 17.0238C5.16224 16.6415 5.0989 16.1615 5.07204 15.638Z" stroke="#CCCCCC" />
                            <path d="M13.8098 7.49289H6.19274C6.17624 7.49289 6.16152 7.48252 6.15597 7.46698L4.13197 1.8028C4.0019 1.43879 3.46508 1.52096 3.44985 1.90721L3.01825 12.8499C3.0181 12.8538 3.01739 12.8575 3.01614 12.8611L1.04554 18.5658C0.987181 18.7347 1.03002 18.9222 1.15599 19.049L3.62239 21.5322L5.49682 23.4435C5.65078 23.6005 5.90947 23.5791 6.03561 23.399L6.56882 22.6376C6.57628 22.627 6.58856 22.6207 6.60156 22.621L8.58818 22.6592C8.60149 22.6595 8.61375 22.6665 8.62071 22.6778L9.71912 24.4679C9.84163 24.6676 10.1322 24.6664 10.253 24.4657L11.3295 22.6781C11.3364 22.6666 11.3488 22.6595 11.3622 22.6592L13.3992 22.621C13.4129 22.6207 13.4257 22.6276 13.433 22.6392L13.886 23.3573C14.0095 23.553 14.2851 23.578 14.4418 23.4078L16.1149 21.5908L18.7815 19.0861C18.9147 18.9609 18.963 18.7698 18.9052 18.5964L16.9991 12.8734C16.998 12.87 16.9973 12.8664 16.9972 12.8627L16.525 1.90927C16.5084 1.52298 15.9711 1.44288 15.8425 1.80751L13.8466 7.46683C13.8411 7.48245 13.8263 7.49289 13.8098 7.49289Z" stroke="#CCCCCC" stroke-linecap="round" />
                        </svg>
                        <span class="login-text">My AORUS</span>
                    </button>
                    <div class="login-popup">
                        <ul class="login-link-list">
                            ${MemberInfoList(LoginArea)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div >
    <div class="header-curtain"></div>
`)
    }
}

const renderTemplate = (template, data) => {
    if (Array.isArray(data.children)) {
        data.children = data.children.join('');
    }

    let strhtml = template(data) || "";
    return strhtml.replace(/\s\w+=['"]null['"]/g, '').trim();
};
const components = {};
Object.entries(template).forEach(([name, template]) => {
    components[name] = (data) => {
        midTextTransformer(data);
        return renderTemplate(template, data);
    }
});

const menuIconClass = {
    3: "icon-nav-pi-mb",
    4: "icon-nav-pi-graphics",
    5: "icon-nav-pi-monitor",
    6: "icon-nav-pi-laptop",
    7: "icon-nav-pi-desktop",
    8: "icon-nav-pi-peripheral",
    9: "icon-nav-pi-components",
};

export const { FlyoutNavItem, Submenu, SubmenuGroup, SubmenuItem, AorusHeader, MemberInfoList, MemberInfoItem, SearchItem } = components;
export default AorusHeader;